// eslint-disable-next-line @typescript-eslint/no-explicit-any
type EventHandler = (...args: any[]) => void;

export class EventEmitter {
	private _events: Record<string, Set<EventHandler>> = {};

	on(name: string, handler: EventHandler) {
		if (!this._events[name]) this._events[name] = new Set();

		this._events[name].add(handler);
	}

	once(name: string, handler: EventHandler) {
		const temp = (...args: unknown[]) => {
			this.removeListener(name, temp);
			handler.apply(this, args);
		};

		this.on(name, temp);
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	emit(name: string, ...args: any[]) {
		if (!this._events[name]) return;

		for (const handler of this._events[name]) {
			handler.apply(this, args);
		}
	}

	removeListener(name: string, handler: EventHandler) {
		if (!this._events[name]) return;

		this._events[name].delete(handler);
	}
}
